import PropTypes from 'prop-types';
import EffectDateEditField from '@@viewCommonComponents/EffectDateEditField.jsx';
import { Icon } from '@fasstech/middle-design-system';
import useMembersInformation from '../hooks/useMembersInformation';
import { CardContent } from '@@viewCommonComponents/CardContainer';

const MembersInformations = ({
  customer,
  onModifyEffectDate,
  onEditCustomerGrantees,
  getMiddleText,
  getMiddleBoolean,
  regimeObligatoire,
  jobs,
  professionalSituations,
  socioProfessionalCategories,
  activities,
  editIsLocked = false
}) => {
  const { customerCardOptions, form } = useMembersInformation({
    regimeObligatoire,
    jobs,
    professionalSituations,
    socioProfessionalCategories,
    activities,
    customer,
    getMiddleText,
    getMiddleBoolean
  });

  return (
    <div className={'flex flex-col md:flex-row! justify-between items-start gap-8'}>
      <div className="flex">
        <div id="datePicker" className="w-[170px] mb-6 mt-4">
          <EffectDateEditField
            label={getMiddleText('PROCESSDEVENTE_EFFECT_DATE_PLACEHOLDER')}
            value={form.watch('offer.effectDate')}
            onEdit={onModifyEffectDate}
            editIsLocked={editIsLocked}
          />
        </div>
      </div>

      <div className={'w-full'}>
        {customer && (
          <div className="relative border border-[#CBCCCD] rounded-md w-full min-w-[30%] h-fit">
            {onEditCustomerGrantees && (
              <Icon
                name={'circlePen'}
                size={30}
                wrapperClassName={`absolute top-3 right-3 ${editIsLocked ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                onClick={editIsLocked ? undefined : () => onEditCustomerGrantees(0)}
                data-testid="BENEFICIARY_CARD_EDIT"
              />
            )}
            <div className="flex flex-col items-center p-4">
              <Icon name={'informations_adherent'} size={50} />
              <span className="text-xl font-bold">{getMiddleText('CLIENT_TITLE')}</span>
              <CardContent data={customerCardOptions} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

MembersInformations.propTypes = {
  customer: PropTypes.object,
  onModifyEffectDate: PropTypes.func,
  onEditCustomerGrantees: PropTypes.func,
  getMiddleText: PropTypes.func,
  getMiddleBoolean: PropTypes.func,
  regimeObligatoire: PropTypes.object,
  editIsLocked: PropTypes.bool
};

export default MembersInformations;
